import React from 'react'
import { Footer as FooterSuite } from 'rsuite'
import tenantConfig from 'config/tenant'
import './footer.scss'

/**
 * Page footer — sits at the bottom of every authenticated page.
 *
 * <p>Left: tenant copyright. Right: build credit linking to multigenesys.com
 * (kept as a single small line so it doesn't compete with page content).
 */
const Footer: React.FC = () => {
  const year = new Date().getFullYear()
  return (
    <FooterSuite className="footer">
      <div className="footer__left" />
      <div className="footer__right">
        <span className="footer__copyright">
          © {year} {tenantConfig.copyrightHolder}.{' '}
          <span className="footer__copyright-suffix">All rights reserved.</span>
        </span>
        <span className="footer__sep" aria-hidden>
          •
        </span>
        <span className="footer__credit">
          Software designed &amp; developed by{' '}
          <a
            href="https://multigenesys.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__credit-link"
          >
            multigenesys.com
          </a>
        </span>
      </div>
    </FooterSuite>
  )
}

export default Footer
